/* Litos Wardrobe — 3D-Marke.

   Eine WebGL-Instanz. Startet gross im Hero, wandert beim Scrollen in den
   Header. Geometrie aus dem Original-Logo — kein Bild, kein Video.

   three.js kommt aus dem Theme und von nirgends sonst. Fällt es aus, setzt
   lw-no3d und das flache SVG übernimmt.

   Aufbau 01.08.2026:
   - Das Schild ist **kein einzelnes Mesh mehr**. Es wird aus dem Umriss in
     rund dreißig Ringsegmente zerlegt, die einzeln einfliegen und sich zum
     Wappen schliessen. Jedes Segment stammt aus echten Punkten des Logos,
     nicht aus einer Annahme über seine Form.
   - Das Metall **nimmt die Palette an**: der Grundton ist ein Gemisch aus
     Vordergrund und Akzent, dazu ein Schimmer in Akzentfarbe.
   - **Zeigerreaktion:** Segmente in der Nähe des Mauszeigers weichen nach
     aussen aus und federn zurück.
   - Kein Hintergrund: man sieht durch das Schild.
*/
(function (win, doc) {
  'use strict';

  var GEO = {"shield":[[-2.02,50.0],[-9.13,45.61],[-17.42,41.85],[-28.29,38.5],[-40.98,36.48],[-40.28,20.38],[-38.89,8.47],[-36.72,-2.06],[-33.87,-10.63],[-30.17,-11.6],[-27.46,-14.04],[-26.34,-17.25],[-27.25,-22.2],[-23.55,-28.95],[-19.44,-34.67],[-10.87,-43.45],[-3.41,-49.09],[-1.25,-50.0],[6.97,-43.94],[15.19,-35.78],[21.74,-27.07],[27.25,-17.25],[31.08,-7.91],[34.29,3.38],[36.17,14.46],[36.93,27.0],[34.84,29.02],[33.87,31.32],[33.8,34.18],[34.56,36.83],[24.67,38.43],[16.17,40.94],[9.9,43.52],[-1.25,50.0]],"inner":[[-1.67,46.52],[-7.46,43.03],[-16.31,38.99],[-27.67,35.51],[-37.84,33.76],[-37.21,20.8],[-35.96,9.79],[-34.22,0.66],[-31.71,-7.7],[-27.39,-9.72],[-24.6,-12.79],[-23.28,-16.83],[-23.34,-19.48],[-24.04,-21.71],[-17.56,-32.09],[-10.87,-39.34],[-1.53,-46.52],[6.76,-40.03],[13.17,-33.41],[19.09,-25.47],[24.39,-16.06],[28.22,-6.72],[31.29,4.15],[33.1,14.88],[33.87,25.54],[31.29,29.23],[30.66,31.81],[30.73,34.18],[21.53,36.06],[14.29,38.36],[4.6,42.75]],"bolt":[[[41.25,37.18],[40.7,37.32],[5.37,6.03],[4.11,6.17],[3.41,7.14],[3.41,15.64],[2.86,15.64],[-9.9,-7.84],[-10.17,-8.89],[-9.41,-8.75],[-3.69,-1.43],[-2.51,-1.29],[-1.39,-2.54],[-0.07,-11.81],[0.49,-11.81],[41.25,36.76]],[[-16.38,5.05],[-16.93,5.05],[-41.18,-28.33],[-41.25,-29.09],[-40.63,-29.02],[-14.01,-12.23],[-14.01,-11.67],[-15.26,-11.74],[-23.0,-13.97],[-23.83,-13.76],[-24.53,-12.79],[-24.46,-12.02],[-16.38,4.49]]],"dot":[[-14.36,-9.37],[-14.63,-9.65],[-14.63,-9.72],[-14.7,-9.79],[-14.7,-9.93],[-14.77,-10.0],[-14.77,-10.77],[-14.7,-10.84],[-14.7,-10.98],[-14.63,-11.05],[-14.63,-11.11],[-14.43,-11.32],[-14.36,-11.32],[-14.22,-11.46],[-14.08,-11.46],[-14.01,-11.53],[-13.24,-11.53],[-13.17,-11.46],[-13.03,-11.46],[-12.96,-11.39],[-12.89,-11.39],[-12.61,-11.11],[-12.61,-11.05],[-12.54,-10.98],[-12.54,-10.84],[-12.47,-10.77],[-12.47,-10.0],[-12.54,-9.93],[-12.54,-9.79],[-12.68,-9.65],[-12.68,-9.58],[-12.89,-9.37],[-12.96,-9.37],[-13.03,-9.3],[-13.17,-9.3],[-13.24,-9.23],[-14.01,-9.23],[-14.08,-9.3],[-14.22,-9.3],[-14.29,-9.37]]};

  var HEADER_PX = 34;

  function rgb(name, fb) {
    var v = getComputedStyle(doc.documentElement).getPropertyValue(name).trim();
    var p = (v || fb).replace(/[^\d,.\s]/g, '').split(',').map(parseFloat);
    if (p.length < 3 || p.some(isNaN)) p = fb.split(',').map(Number);
    return p;
  }
  function hex(p) { return (Math.round(p[0]) << 16) + (Math.round(p[1]) << 8) + Math.round(p[2]); }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function luma(p) { return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255; }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function easeBack(t) { var c = 1.42; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); }

  function shapeOf(THREE, pts) {
    var s = new THREE.Shape();
    s.moveTo(pts[0][0], pts[0][1]);
    for (var i = 1; i < pts.length; i++) s.lineTo(pts[i][0], pts[i][1]);
    s.closePath();
    return s;
  }

  function makeEnv(THREE, renderer, bg, accent) {
    var pmrem = new THREE.PMREMGenerator(renderer);
    var sc = new THREE.Scene();
    var top = new THREE.Color().setRGB(
      Math.min(1, bg[0] / 510 + 0.56), Math.min(1, bg[1] / 510 + 0.56), Math.min(1, bg[2] / 510 + 0.59));
    var bot = new THREE.Color(hex(mix(bg, [0, 0, 0], 0.6)));
    var side = new THREE.Color(hex(mix(accent, [255, 255, 255], 0.28)));
    var g = new THREE.SphereGeometry(60, 32, 20);
    var m = new THREE.ShaderMaterial({
      side: THREE.BackSide,
      uniforms: { cT: { value: top }, cB: { value: bot }, cS: { value: side } },
      vertexShader: 'varying vec3 v;void main(){v=normalize(position);gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);}',
      fragmentShader: 'uniform vec3 cT;uniform vec3 cB;uniform vec3 cS;varying vec3 v;' +
        'void main(){float h=v.y*.5+.5;vec3 c=mix(cB,cT,smoothstep(.22,.96,h));' +
        'float b=smoothstep(.55,.93,v.x)+smoothstep(-.55,-.96,-v.x)*.6;' +
        'c=mix(c,cS,clamp(b,0.,1.)*.55);' +
        'float strip=smoothstep(.30,.34,h)-smoothstep(.40,.46,h);c+=strip*.6;' +
        'c+=smoothstep(.87,1.,v.y)*1.8;gl_FragColor=vec4(c,1.);}'
    });
    sc.add(new THREE.Mesh(g, m));
    var t = pmrem.fromScene(sc, 0.04).texture;
    g.dispose(); m.dispose(); pmrem.dispose();
    return t;
  }

  function mountHeaderAnchor() {
    if (doc.querySelector('[data-lito-anchor="header"]')) return;
    var link = doc.querySelector('.header__heading-link, .header__heading a, .header__heading');
    if (!link) return;
    var img = link.querySelector('img');
    if (img) img.style.display = 'none';
    var span = doc.createElement('span');
    span.className = 'lw-mark lw-mark--header';
    span.setAttribute('data-lito-anchor', 'header');
    span.setAttribute('aria-hidden', 'true');
    var tpl = doc.querySelector('[data-lito-svg]');
    if (tpl) span.innerHTML = tpl.innerHTML;
    link.insertBefore(span, link.firstChild);
    link.classList.add('lw-wordmark');
  }

  function start() {
    var THREE = win.THREE;
    if (!THREE) { doc.documentElement.classList.add('lw-no3d'); return; }

    mountHeaderAnchor();

    var header = doc.querySelector('[data-lito-anchor="header"]');
    var hero = doc.querySelector('[data-lito-anchor="hero"]');
    if (!header && !hero) return;

    var reduce = win.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var probe = doc.createElement('canvas');
    if (!(probe.getContext('webgl2') || probe.getContext('webgl'))) {
      doc.documentElement.classList.add('lw-no3d');
      return;
    }

    var bg = rgb('--lito-bg', '12,28,51');
    var fg = rgb('--lito-fg', '240,244,250');
    var accent = rgb('--lito-accent-rgb', '90,150,224');
    var dark = luma(bg) < 0.45;

    var canvas = doc.createElement('canvas');
    canvas.id = 'lw-stage';
    canvas.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(canvas);

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setClearAlpha(0);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = dark ? 1.18 : 0.96;
    if (THREE.ColorManagement) THREE.ColorManagement.enabled = true;
    if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;

    var scene = new THREE.Scene();
    scene.environment = makeEnv(THREE, renderer, bg, accent);

    var FOV = 18, DIST = 520;
    var camera = new THREE.PerspectiveCamera(FOV, 1, 10, 2000);
    camera.position.set(0, 0, DIST);

    var root = new THREE.Group();
    var spin = new THREE.Group();
    var body = new THREE.Group();
    spin.add(body); root.add(spin); scene.add(root);

    function ex(shape, depth, bevel, seg) {
      return new THREE.ExtrudeGeometry(shape, {
        depth: depth, bevelEnabled: true, bevelThickness: bevel * 1.25,
        bevelSize: bevel, bevelSegments: seg || 3, curveSegments: 5
      });
    }

    /* --- Farbe: das Metall nimmt die Palette an ------------------------- */
    function metallton() {
      var basis = mix(fg, accent, 0.32);
      return dark ? mix(basis, [255, 255, 255], 0.06) : mix(basis, [0, 0, 0], 0.06);
    }

    var Phys = THREE.MeshPhysicalMaterial || THREE.MeshStandardMaterial;
    var metal = metallton();

    var rimMat = new Phys({
      color: hex(metal),
      metalness: 0.92, roughness: 0.22, envMapIntensity: 1.5,
      clearcoat: 1.0, clearcoatRoughness: 0.10,
      transparent: true, opacity: 0
    });

    var boltMat = new Phys({
      color: hex(metal),
      metalness: 0.98, roughness: 0.10, envMapIntensity: 1.8,
      clearcoat: 1.0, clearcoatRoughness: 0.04,
      emissive: hex(mix(metal, accent, 0.5)), emissiveIntensity: 0,
      transparent: true, opacity: 0
    });
    if ('iridescence' in boltMat) {
      boltMat.iridescence = 0.6;
      boltMat.iridescenceIOR = 1.9;
      boltMat.iridescenceThicknessRange = [180, 520];
    }

    var dotMat = new Phys({
      color: hex(mix(metal, [255, 255, 255], 0.30)),
      metalness: 0.98, roughness: 0.07, envMapIntensity: 1.95,
      clearcoat: 1.0, clearcoatRoughness: 0.03,
      transparent: true, opacity: 0
    });

    /* --- Das Schild in Ringsegmente zerlegen ---------------------------
       Zwischen äusserem Umriss und innerer Kontur entsteht für je zwei
       benachbarte Punkte ein Viereck. Die Punktzahlen unterscheiden sich,
       deshalb wird die innere Kontur über das Verhältnis abgetastet. */

    var teile = [];
    var A = GEO.shield, B = GEO.inner;
    var N = A.length - 1;

    for (var i = 0; i < N; i++) {
      var j0 = Math.round(i * (B.length - 1) / N);
      var j1 = Math.round((i + 1) * (B.length - 1) / N);
      if (j1 === j0) j1 = (j0 + 1) % B.length;

      var quad = [A[i], A[(i + 1) % A.length], B[j1 % B.length], B[j0 % B.length]];
      var mesh = new THREE.Mesh(ex(shapeOf(THREE, quad), 7, 0.55, 2), rimMat);

      var cx = (quad[0][0] + quad[1][0] + quad[2][0] + quad[3][0]) / 4;
      var cy = (quad[0][1] + quad[1][1] + quad[2][1] + quad[3][1]) / 4;
      var len = Math.max(1, Math.sqrt(cx * cx + cy * cy));

      mesh.userData.home = mesh.position.clone();
      mesh.userData.nx = cx / len;
      mesh.userData.ny = cy / len;
      mesh.userData.cx = cx;
      mesh.userData.cy = cy;
      /* Reihenfolge gestreut statt im Uhrzeigersinn — es soll nach Montage
         aussehen, nicht nach Ladebalken. */
      mesh.userData.ord = ((i * 7) % N) / N;
      mesh.userData.spin = (i % 2 ? 1 : -1) * (0.5 + (i % 5) * 0.18);
      body.add(mesh);
      teile.push(mesh);
    }

    var lobes = [];
    GEO.bolt.forEach(function (pts, k) {
      var m = new THREE.Mesh(ex(shapeOf(THREE, pts), 11, 1.0, 4), boltMat);
      m.position.z = 8;
      m.userData.home = m.position.clone();
      m.userData.dir = k === 0 ? 1 : -1;
      body.add(m); lobes.push(m);
    });

    var dot = new THREE.Mesh(ex(shapeOf(THREE, GEO.dot), 13, 0.5, 3), dotMat);
    dot.position.z = 8;
    dot.userData.home = dot.position.clone();
    body.add(dot);

    var bb = new THREE.Box3().setFromObject(body);
    var ctr = new THREE.Vector3();
    bb.getCenter(ctr);
    body.position.set(-ctr.x, -ctr.y, -ctr.z);
    var UNITS = Math.max(bb.max.x - bb.min.x, bb.max.y - bb.min.y);

    /* --- Licht --- */
    var key = new THREE.DirectionalLight(0xffffff, dark ? 2.8 : 2.1);
    key.position.set(-70, 95, 130); scene.add(key);
    var rimL = new THREE.DirectionalLight(hex(mix(accent, [255, 255, 255], 0.25)), dark ? 2.6 : 1.4);
    rimL.position.set(120, 25, -95); scene.add(rimL);
    var edge = new THREE.DirectionalLight(hex(mix(fg, accent, 0.4)), dark ? 1.35 : 0.75);
    edge.position.set(-105, -70, 40); scene.add(edge);
    var fill = new THREE.DirectionalLight(hex(mix(bg, [255, 255, 255], 0.55)), 0.5);
    fill.position.set(55, -85, 65); scene.add(fill);
    var ambient = new THREE.AmbientLight(hex(bg), dark ? 0.30 : 0.72);
    scene.add(ambient);

    var repaintQueued = false;
    function repaint() {
      repaintQueued = false;
      bg = rgb('--lito-bg', '12,28,51');
      fg = rgb('--lito-fg', '240,244,250');
      accent = rgb('--lito-accent-rgb', '90,150,224');
      dark = luma(bg) < 0.45;
      var m = metallton();

      rimMat.color.setHex(hex(m));
      boltMat.color.setHex(hex(m));
      boltMat.emissive.setHex(hex(mix(m, accent, 0.5)));
      dotMat.color.setHex(hex(mix(m, [255, 255, 255], 0.30)));

      key.intensity = dark ? 2.8 : 2.1;
      rimL.color.setHex(hex(mix(accent, [255, 255, 255], 0.25)));
      rimL.intensity = dark ? 2.6 : 1.4;
      edge.color.setHex(hex(mix(fg, accent, 0.4)));
      edge.intensity = dark ? 1.35 : 0.75;
      fill.color.setHex(hex(mix(bg, [255, 255, 255], 0.55)));
      ambient.color.setHex(hex(bg));
      ambient.intensity = dark ? 0.30 : 0.72;
      renderer.toneMappingExposure = dark ? 1.18 : 0.96;

      if (scene.environment && scene.environment.dispose) scene.environment.dispose();
      scene.environment = makeEnv(THREE, renderer, bg, accent);
    }

    doc.addEventListener('lito:farbe', function () {
      if (repaintQueued) return;
      repaintQueued = true;
      win.requestAnimationFrame(repaint);
    });

    var W = 0, H = 0, unitPerPx = 1;
    function resize() {
      W = win.innerWidth; H = win.innerHeight;
      renderer.setPixelRatio(Math.min(win.devicePixelRatio || 1, 1.75));
      renderer.setSize(W, H, false);
      camera.aspect = W / H;
      camera.updateProjectionMatrix();
      unitPerPx = (2 * DIST * Math.tan((FOV * Math.PI / 180) / 2)) / H;
    }
    resize();
    win.addEventListener('resize', resize, { passive: true });

    function rectOf(el, fb) {
      if (!el) return null;
      var r = el.getBoundingClientRect();
      return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, size: Math.min(r.width, r.height) || fb };
    }

    var handoff = 1;
    function measure() {
      if (!hero || !header) { handoff = 1; return; }
      var hr = hero.getBoundingClientRect();
      var kr = header.getBoundingClientRect();
      handoff = Math.max(1, (hr.top + win.scrollY + hr.height / 2) - (kr.top + kr.height / 2));
    }
    measure();
    win.addEventListener('resize', measure, { passive: true });
    win.addEventListener('load', function () { resize(); measure(); });

    var mx = 0, my = 0, sx = 0, sy = 0, px = 0, py = 0, zeiger = false;
    if (win.matchMedia('(pointer:fine)').matches && !reduce) {
      win.addEventListener('pointermove', function (e) {
        mx = (e.clientX / win.innerWidth) * 2 - 1;
        my = (e.clientY / win.innerHeight) * 2 - 1;
        px = e.clientX; py = e.clientY;
        zeiger = true;
      }, { passive: true });
      win.addEventListener('pointerleave', function () { zeiger = false; }, { passive: true });
    }

    var t0 = performance.now();
    var INTRO = reduce ? 0.001 : 2.1;
    doc.documentElement.classList.add('lw-3d-live');

    function frame(now) {
      win.requestAnimationFrame(frame);
      if (doc.hidden) return;
      var t = (now - t0) / 1000;
      var p = Math.min(1, t / INTRO);

      var e = easeInOut(hero ? clamp01(win.scrollY / handoff) : 1);
      var a = rectOf(hero, 320), b = rectOf(header, HEADER_PX);
      var target = (a && b)
        ? { cx: a.cx + (b.cx - a.cx) * e, cy: a.cy + (b.cy - a.cy) * e, size: a.size + (b.size - a.size) * e }
        : (a || b);
      if (!target) return;

      root.position.x = (target.cx - W / 2) * unitPerPx;
      root.position.y = -(target.cy - H / 2) * unitPerPx;
      var skala = (target.size * unitPerPx / UNITS) * (0.88 + 0.12 * easeOut(p));
      root.scale.setScalar(skala);

      rimMat.opacity = easeOut(Math.min(1, t / (INTRO * 0.35)));

      /* Zeiger in die lokale Ebene des Wappens umrechnen. */
      var zx = 0, zy = 0, nah = zeiger && e < 0.5;
      if (nah) {
        zx = ((px - target.cx) * unitPerPx) / Math.max(0.0001, skala);
        zy = (-(py - target.cy) * unitPerPx) / Math.max(0.0001, skala);
      }
      var R = UNITS * 0.42, kraft = (1 - e) * 9;

      for (var i = 0; i < teile.length; i++) {
        var m = teile[i], u = m.userData;

        /* Zusammenbau: jedes Segment mit eigenem Versatz und eigener Zeit. */
        var sp = clamp01((t - INTRO * 0.06 - u.ord * INTRO * 0.42) / (INTRO * 0.46));
        var k = 1 - clamp01(easeBack(sp));

        var ox = u.nx * 190 * k;
        var oy = u.ny * 190 * k;
        var oz = 150 * k;

        /* Zeigerreaktion: nur wenn zusammengebaut. */
        if (nah && sp > 0.98) {
          var dx = u.cx - zx, dy = u.cy - zy;
          var d = Math.sqrt(dx * dx + dy * dy);
          if (d < R) {
            var f = (1 - d / R);
            f = f * f;
            ox += u.nx * kraft * f * 2.2;
            oy += u.ny * kraft * f * 2.2;
            oz += kraft * f * 1.4;
          }
        }

        m.position.set(u.home.x + ox, u.home.y + oy, u.home.z + oz);
        m.rotation.z = u.spin * k;
        m.rotation.x = u.spin * k * 0.5;
        var s = 0.62 + 0.38 * (1 - k);
        m.scale.set(s, s, s);
      }

      var bp = clamp01((t - INTRO * 0.46) / (INTRO * 0.44));
      boltMat.opacity = dotMat.opacity = easeOut(bp);
      var kb = 1 - clamp01(easeBack(bp));
      lobes.forEach(function (m) {
        var h = m.userData.home, d = m.userData.dir;
        m.position.set(h.x + d * 230 * kb, h.y - d * 86 * kb, h.z + 140 * kb);
        m.rotation.z = d * 1.05 * kb;
      });
      dot.position.z = dot.userData.home.z + 140 * kb;

      var fl = t - INTRO * 0.9;
      if (fl > 0 && fl < 0.75) {
        var f2 = fl < 0.08 ? fl / 0.08 : Math.max(0, 1 - (fl - 0.08) / 0.67);
        boltMat.emissiveIntensity = 2.1 * f2 * f2 + 0.06;
        if (!doc.documentElement.dataset.lwFlash && fl > 0.02) {
          doc.documentElement.dataset.lwFlash = '1';
          var st = doc.querySelector('.lw-flash');
          if (st) { st.classList.add('is-on'); setTimeout(function () { st.classList.remove('is-on'); }, 750); }
        }
      } else if (fl >= 0.75) {
        boltMat.emissiveIntensity = 0.06 + Math.sin(t * 0.8) * 0.03;
      }

      var amp = 1 - e * 0.72;
      var gx = (mx * 0.26 + Math.sin(t * 0.27) * 0.05) * amp;
      var gy = (-my * 0.17 + Math.sin(t * 0.21 + 1.1) * 0.035) * amp;
      sx += (gx - sx) * 0.05;
      sy += (gy - sy) * 0.05;
      spin.rotation.y = sx + (1 - p) * -0.7;
      spin.rotation.x = sy;
      spin.rotation.z = Math.sin(t * 0.17) * 0.015 * amp;

      renderer.render(scene, camera);
    }
    win.requestAnimationFrame(frame);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
